import { Drawer as VaulDrawer } from 'vaul'
import { Content } from './Content'
import { Overlay } from './Overlay'
import { Handle } from './Handle'
import { InnerContent } from './InnerContent'
import { Top } from './Top'
import { Container } from './Container'
import { ScrollableContainer } from './ScrollableContainer'
import { Root } from './Root'
import { NestedRoot } from './NestedRoot'
import { Close } from './Close'
import { Action, Back } from './Back'

export const Drawer = {
  ...VaulDrawer,
  Root,
  NestedRoot,
  Handle,
  Content,
  InnerContent,
  Overlay,
  Top,
  Close,
  Back,
  Action,
  Container,
  ScrollableContainer,
}
